<template>
  <div class="s-page" ref="sPage">
    <div class="s-tab">
      <div class="s-item" v-for="(item) in tabList" :key="item.id" @click="handleTab(item.id)" :class="tabIndex==item.id?'active':''">
        {{item.name}}
      </div>
    </div>
    <transition>
      <!-- @getScrollLeft="getScrollLeft" :lastLeft="lastLeft" @getlastLeft="getlastLeft" v-show="showScheduleTop"-->
      <!-- <ScheduleCompetitionTop ref="scheduleTop"  v-show="showScheduleTop" :showScheduleTop="showScheduleTop"/> -->
    </transition>
    <component :is="currentCompent" @medalRowClick="medalRowClick"  :showScheduleTop="showScheduleTop"></component>
  </div>
</template>

<script>
import ScheduleCompetition from '@district/components/common/ScheduleCompetition.vue'
import ScheduleCompetitionTop from '@district/components/common/ScheduleCompetitionTop.vue'
import SchMedal from './components/SchMedal.vue'
import RecordBreaking from './components/RecordBreaking.vue'
import RankingScore from './components/RankingScore.vue'
import Athletes from './components/Athletes.vue'
export default {
  props: {
  },
  components: {
    ScheduleCompetition,
    ScheduleCompetitionTop,
    SchMedal,
    RecordBreaking,
    RankingScore,
    Athletes,
  },
  data () {
    return {
      tabIndex:2,
      tabList: [
        // {id:1,name:'赛程'},
        {id:2,name:'奖牌榜'},
        {id:3,name:'积分榜'},
      ],
      currentCompent:'SchMedal',
      showScheduleTop:false,
      scrollLeft:0,
      lastLeft:0,
    }
  },
  mounted (){
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    // getlastLeft(lastLeft){
    //   this.lastLeft=lastLeft
    // },
    // getScrollLeft(scrollLeft){
    //   this.scrollLeft=scrollLeft
    // },
    //监听页面滚动
    handleScroll () {
      this.$nextTick(()=>{
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if(scrollTop>=370){
          this.showScheduleTop=true
        }else{
          this.showScheduleTop=false
        }
      })
    },
    handleTab (index) {
      this.tabIndex=index
      switch (index) {
      case 1:
        this.currentCompent='ScheduleCompetition'
        break
      case 2:
        this.currentCompent='SchMedal'
        break
      case 3:
        this.currentCompent='RankingScore' // RecordBreaking
        break
      default:
        break
      }
    },
    medalRowClick (item) {
      console.log(item)
      let str=JSON.stringify(item)
      this.$router.push({name:'DelegationDetail',query:{item:encodeURIComponent(str)}})
    }
  },
}

</script>

<style lang="scss" scoped>
.s-page{
  width: 100%;
  .s-tab{
    width:1200px;
    margin:0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 130px;
    margin-bottom: 20px;
    .s-item{
      width: 140px;
      height: 46px;
      text-align: center;
      line-height: 46px;
      margin-right: 30px;
      cursor: pointer;
      font-size: 18px;
      border-radius: 5px;
    }
    .active{
      background-color: #009EDF;
      color: #FFFFFF;
      font-size: 20px;
    }
  }
  .bg{
      background-color: #FBFBFB;
      min-height: 500px;
      border-top: 1px solid #E4E4E4;
      padding-top: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/district/views/schedule/Home.vue